module.exports = __webpack_public_path__ + "static/media/1POLICY37.17bcab59.jpg";